import { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseDiscountManagment } from "./UseDiscountManagment";
import { useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSearchParams } from "react-router-dom";
import { UseDiscountCode } from "./Code/UseDiscountCode";
import { UseMyPC } from "../../hooks/UseMyPC";

export default function CandidateList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const { getCodeCandidate } = UseDiscountCode();
  const { getBatchCandidate, getDirectCandidate } = UseDiscountManagment();
  const [name, setName] = useState();
  const [productRes, setProductRes] = useState();
  const [pageState, setPageState] = useState({
    page: location.state && location.state.page ? location.state.page : 1,
  });

  useEffect(() => {
    if (searchParams && searchParams.get("discount") == "Batch") {
      setName("پیشنهادات تخفیف بچ");
      getBatchCandidate(myPc, (products) => {
        setProductRes(products);
      });
    } else if (searchParams && searchParams.get("discount") == "Direct") {
      setName("پیشنهادات تخفیف مستقیم");
      getDirectCandidate(myPc, (products) => {
        setProductRes(products);
      });
    } else if (searchParams && searchParams.get("discount") == "DiscountCode") {
      setName("پیشنهادات کد تخفیف");
      getCodeCandidate(myPc, (products) => {
        setProductRes(products);
      });
    }
  }, [myPc, searchParams]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },

    {
      field: "productName",
      headerName: "نام محصول",
      width: 300,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "group",
      headerName: "گروه",
      width: 220,
      align: "center",
      headerAlign: "center",
      hide:
        searchParams && searchParams.get("discount") == "Batch" ? true : false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ textAlign: "center", whiteSpace: "normal" }}
          >
            {cellValues.row.group}
          </Typography>
        );
      },
    },
    {
      field: "brand",
      headerName: "برند",
      width: 170,
      align: "center",
      headerAlign: "center",
      hide:
        searchParams && searchParams.get("discount") == "Batch" ? true : false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ textAlign: "center", whiteSpace: "normal" }}
          >
            {cellValues.row.brand}
          </Typography>
        );
      },
    },
    {
      field: "expireDay",
      width: 100,
      align: "center",
      headerName: "روز انقضا",
      headerAlign: "center",
      hide:
        searchParams && searchParams.get("discount") == "Batch" ? false : true,
    },
    {
      field: "shamsiExpire",
      width: 130,
      align: "center",
      headerName: "تاریخ انقضا",
      headerAlign: "center",
      hide:
        searchParams && searchParams.get("discount") == "Batch" ? false : true,
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/discountmanagment",
          },
          {
            name: name ? name : "پیشنهادات تخفیف",
            url: `/discountmanagment/candidateList?discount=${searchParams.get(
              "discount"
            )}`,
          },
        ],
      }}
    >
      {productRes ? (
        <DataGrid
          disableVirtualization
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={productRes.products}
          paginationMode="server"
          pageSize={productRes.pageCondition.pageCount}
          page={productRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            productRes?.pageCondition.totalItemCount
              ? productRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              rowCount: productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : "",
            },
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
              {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .red": {
              backgroundColor: "#ff9c9c !important",
            },
            "& .green": {
              backgroundColor: "#56ff004f !important",
            },
            "& .orang": {
              backgroundColor: "#ffa15b !important",
            },
            "& .yellow": {
              backgroundColor: "#ffed8b !important",
            },
          }}
          getRowClassName={(params) => {
            if (
              searchParams &&
              searchParams.get("discount") == "Batch" &&
              params.row.shamsiLogdate
            ) {
              return "green";
            }
            if (
              searchParams &&
              searchParams.get("discount") == "Batch" &&
              params.row.expireDay < 21
            ) {
              return "red";
            }
            if (
              searchParams &&
              searchParams.get("discount") == "Batch" &&
              params.row.expireDay < 31
            ) {
              return "orang";
            }
            if (
              searchParams &&
              searchParams.get("discount") == "Batch" &&
              params.row.expireDay < 181
            ) {
              return "yellow";
            }
            if (
              searchParams &&
              searchParams.get("discount") == "Batch" &&
              params.row.shamsiLogdate
            ) {
              return "green";
            }
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
